module.exports = __webpack_public_path__ + "static/media/bg_left.c52a5534.png";